import { FormattedNumber } from 'react-intl';
import FormattedCurrency from '../../../format-currency/FormattedCurrency';
import IOMessageWithMarkers from '../../../native-types/IOMessageWithMarkers';

export const CSS_HANDLES = [
	'installments',
	'installmentsNumber',
	'installmentValue',
	'installmentsTotalValue',
	'interestRate',
	'paymentSystemName',
] as const;

interface Props {
	message: string;
	markers: string[];
	installment: any;
	handles: any;
	handlesModifierFunction: any;
	componentId?: string;
	blockClass?: string;
}

function InstallmentsRenderer({
	message,
	markers,
	installment,
	handles,
	blockClass,
	handlesModifierFunction: withModifiers,
	componentId,
}: Props) {
	const { Value, NumberOfInstallments, InterestRate, PaymentSystemName, TotalValuePlusInterestRate } = installment;

	const hasMoreThanOne = NumberOfInstallments > 1;

	const hasInterest = InterestRate !== 0;

	const interestRatePercent = InterestRate / 100;

	return (
		<span data-selection={componentId} className={handles.installments}>
			<IOMessageWithMarkers
				message={message}
				blockClass={blockClass}
				markers={markers}
				handleBase="installments"
				values={{
					installmentsNumber: (
						<span key="installmentsNumber" className={withModifiers('installmentsNumber', `${NumberOfInstallments}`)}>
							{NumberOfInstallments && <FormattedNumber value={NumberOfInstallments} />}
						</span>
					),
					installmentValue: (
						<span key="installmentValue" className={handles.installmentValue}>
							<FormattedCurrency value={Value} />
						</span>
					),
					installmentsTotalValue: (
						<span key="installmentsTotalValue" className={handles.installmentsTotalValue}>
							<FormattedCurrency value={TotalValuePlusInterestRate} />
						</span>
					),
					interestRate: (
						<span key="interestRate" className={handles.interestRate}>
							{interestRatePercent && (
								<FormattedNumber
									value={interestRatePercent}
									style="percent"
									maximumFractionDigits={2}
									minimumFractionDigits={0}
								/>
							)}
						</span>
					),
					paymentSystemName: (
						<span key="paymentSystemName" className={handles.paymentSystemName}>
							{PaymentSystemName}
						</span>
					),
					hasInterest,
					hasMoreThanOne,
				}}
			/>
		</span>
	);
}

export default InstallmentsRenderer;
